import React from "react";
import { ProductDetailPageResult } from "../ProductDetailPageResult";
interface Props {
  product: ProductDetailPageResult;
}
const ThreeDModelSchema = ({
  product
}: Props) => {
  const {
    header,
    modelFiles
  } = product;
  const schema = {
    "@context": "https://schema.org",
    "@type": "3DModel",
    name: header,
    encoding: [{
      "@type": "MediaObject",
      contentUrl: modelFiles?.absoluteGlbFilePath,
      encodingFormat: "model/gltf-binary"
    }, {
      "@type": "MediaObject",
      contentUrl: modelFiles?.absoluteUsdzFilePath,
      encodingFormat: "model/vnd.usdz+zip"
    }]
  };
  return <script type="application/ld+json"
  // eslint-disable-next-line react/no-danger
  dangerouslySetInnerHTML={{
    __html: JSON.stringify(schema)
  }} data-sentry-component="ThreeDModelSchema" data-sentry-source-file="ThreeDModelSchema.tsx" />;
};
export default ThreeDModelSchema;